/* Custom JS */

// DOM ready
$(document).ready(function () {

    // toggle searchbox
    $('.search-toggle').on('click', function (e) {
        $('.social-wrap').toggleClass('search-open');
    });

    // event slider
    $('.event-slick, .department').slick({
        dots: false,
        //infinite: true,
        autoplay: false,
        speed: 200,
        slidesToShow: 3,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 2
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1
                }
            }
        ]
    });

    // twitter custom scroll
    if($('.tweets-wrap').length > 0){
        options = {};
        var Scrollbar = window.Scrollbar;
        Scrollbar.init(document.querySelector('.tweets-wrap'), options);
    }

    // main nav set active class
    if ((location.pathname.split("/")[1]) !== ""){
        $('.navbar-nav a[href^="/' + location.pathname.split("/")[1] + '"]').parent().addClass('active');
    } else {
        // home page
        $('.navbar-nav a[href="/"]').parent().addClass('active');
    }

});


// window resize
$(window).on('resize orientationchange', function () {

    setTimeout(function () {

    }, 500);

});